import { useBaseUpdate } from "../../base/hooks/useBaseUpdate";
import { UpdateRoomConditionResponseSchema, UpdateRoomConditionResponseSchemaType } from "../response/UpdateRoomConditionResponse";
import { ChangeRoomConditionSchemaType } from "../schema/ChangeRoomConditionSchema";

const API_VERSION = "v3";

export const useChangeRoomCondition = () => {
    return useBaseUpdate<{ housekeeping_id: string; data: ChangeRoomConditionSchemaType }, UpdateRoomConditionResponseSchemaType>({
        endpoint: ({ housekeeping_id }) => `${API_VERSION}/housekeeping/${housekeeping_id}/edit-room-condition`,
        schema: UpdateRoomConditionResponseSchema,
        contentType: "application/json",
        onSuccess: (data) => data,
        onError: (error) => {
            throw error;
        },
    });
};